import { HotelIcon, LayoutDashboardIcon, LogOutIcon, UserCircle, Users2Icon, Search, BellIcon, User2Icon, Menu, X, ShoppingBag } from 'lucide-react'
import React, { useState } from 'react'
import { useNavigate, Link } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_PROFILE } from '../apollo/Queries';

export default function MainLayout({ children, page }) {
   const [isSidebarOpen, setIsSidebarOpen] = useState(false);
   const navigate = useNavigate()

   const handleLogout = () => {
      setTimeout(() => {
         sessionStorage.removeItem('dmz-token')
         navigate("/");
      }, 500);
   }
   const { data } = useQuery(GET_PROFILE, {
      variables: { page: 0, size: 10 }
   });
   const userType = data?.profile?.data?.userType;

   let navItems = [
      { name: 'Dashboard', icon: <LayoutDashboardIcon size={20} />, path: '/dashboard' },
      { name: 'Restaurants', icon: <HotelIcon size={20} />, path: '/shares' },
      { name: 'Orders', icon: <ShoppingBag size={20} />, path: '/contributions' },
      { name: 'Users', icon: <Users2Icon size={20} />, path: '/users' },
      { name: 'Account', icon: <UserCircle size={20} />, path: '/profile' },
   ];

   if (userType !== 'SUPER_ADMIN') {
      navItems = navItems.filter(item => item.name !== 'Users');
   }

   if (userType !== 'SUPER_ADMIN' && userType !== 'MANAGER') {
      navItems = navItems.filter(item => item.name !== 'Restaurants' && item.name !== 'Orders' && item.name !== 'Account' && item.name !== 'Dashboard');
   }

   return (
      <div className='min-h-screen bg-[#FDFDFD] font-poppins flex'>
         {/* Mobile Menu Button */}
         <button
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            className="fixed top-4 left-4 z-50 p-2 bg-white rounded-xl shadow-lg sm:hidden text-premium-teal"
         >
            {isSidebarOpen ? <X /> : <Menu />}
         </button>

         {/* Sidebar */}
         <aside className={`fixed top-0 left-0 z-40 w-72 h-screen transition-transform duration-500 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} sm:translate-x-0`}>
            <div className="h-full px-6 py-8 overflow-y-auto bg-white border-r border-gray-100 flex flex-col justify-between shadow-[20px_0_50px_rgba(0,0,0,0.02)]">
               <div>
                  <div className="flex items-center gap-3 mb-12 px-2">
                     <div className="w-10 h-10 bg-premium-teal rounded-xl flex items-center justify-center rotate-3 shadow-lg shadow-premium-teal/20">
                        <span className="text-premium-gold font-black text-xl">O</span>
                     </div>
                     <div className="text-premium-teal text-2xl font-black tracking-tighter">ODAZ<span className="text-premium-gold">APP</span></div>
                  </div>

                  <nav className="space-y-3">
                     {navItems.map((item) => (
                        <Link
                           key={item.name}
                           to={item.path}
                           className={`group flex items-center px-4 py-4 rounded-2xl transition-all duration-300 border-l-4 ${page === item.name
                              ? 'bg-premium-teal text-white border-premium-gold shadow-xl shadow-premium-teal/20 scale-[1.02]'
                              : 'bg-transparent text-gray-500 border-transparent hover:bg-gray-50 hover:text-premium-teal hover:border-premium-teal/30'
                              }`}
                        >
                           <span className={`transition-transform duration-300 group-hover:scale-110 ${page === item.name ? 'text-teal-700' : 'text-gray-400 group-hover:text-premium-teal'}`}>
                              {item.icon}
                           </span>
                           <span className={`ms-4 font-black tracking-tight text-xs uppercase ${page === item.name ? 'opacity-100 text-teal-700' : 'opacity-70 group-hover:opacity-100'}`}>{item.name}</span>
                           {page === item.name && (
                              <div className="ms-auto w-1.5 h-1.5 rounded-full bg-premium-gold animate-glow"></div>
                           )}
                        </Link>
                     ))}
                  </nav>
               </div>

               <div className="px-2">
                  {/* <div className="bg-gradient-to-br from-premium-teal to-premium-dark p-6 rounded-[2rem] mb-8 relative overflow-hidden shadow-2xl">
                     <div className="absolute top-0 right-0 w-24 h-24 bg-premium-gold/10 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2"></div>
                     <p className="text-xs text-premium-gold font-black uppercase tracking-widest mb-1 opacity-80">Premium Access</p>
                     <p className="text-white text-sm font-bold leading-snug">Unlock exclusive culinary insights.</p>
                     <button className="mt-4 w-full py-2.5 bg-premium-gold text-premium-teal rounded-xl font-black text-xs uppercase tracking-widest hover:bg-premium-gold-light transition-all">Upgrade</button>
                  </div> */}

                  <button
                     onClick={handleLogout}
                     className="w-full flex items-center justify-center p-4 rounded-2xl text-red-500 font-black text-xs uppercase tracking-[0.2em] border border-red-50 hover:bg-red-50 transition-all group"
                  >
                     <LogOutIcon size={18} className='mr-3 group-hover:-translate-x-1 transition-transform' />
                     Logout System
                  </button>
               </div>
            </div>
         </aside>

         {/* Main Content Area */}
         <div className="flex-1 sm:ml-72 flex flex-col min-h-screen">
            {/* Top Header */}
            <header className="sticky top-0 z-30 h-24 flex items-center justify-between px-8 bg-white/70 backdrop-blur-xl border-b border-gray-100">
               <div className="flex flex-col">
                  <p className="text-[10px] font-black text-premium-gold uppercase tracking-[0.3em] mb-1">Administrative Node</p>
                  <h1 className="text-2xl font-black text-premium-teal tracking-tighter">{page} Interface</h1>
               </div>

               <div className="flex items-center gap-6">
                  <div className="hidden md:flex items-center bg-gray-50 border border-gray-100 rounded-2xl px-4 py-2 w-64 focus-within:ring-2 focus-within:ring-premium-gold/30 transition-all">
                     <Search size={18} className="text-gray-400" />
                     <input type="text" placeholder="Search essence..." className="bg-transparent border-none focus:outline-none text-sm ml-3 text-premium-teal placeholder-gray-400 w-full" />
                  </div>

                  <div className="flex items-center gap-4">
                     <button className="relative p-2.5 text-gray-400 hover:text-premium-teal hover:bg-gray-50 rounded-xl transition-all">
                        <BellIcon size={22} />
                        <span className="absolute top-2.5 right-2.5 w-2 h-2 bg-premium-gold rounded-full border-2 border-white animate-pulse"></span>
                     </button>

                     <div className="h-12 w-12 rounded-2xl bg-premium-gold/10 p-1 cursor-pointer hover:scale-105 transition-transform">
                        <div className="w-full h-full rounded-xl bg-premium-teal flex items-center justify-center text-premium-gold shadow-lg shadow-premium-teal/20">
                           <User2Icon size={20} />
                        </div>
                     </div>
                  </div>
               </div>
            </header>

            {/* Content Body */}
            <main className="flex-1 p-8 bg-gray-50/50">
               <div className="max-w-7xl mx-auto h-full">
                  {children}
               </div>
            </main>
         </div>
      </div>
   )
}
